import { WeaTools } from 'ecCom'

export const getRewardsRecord1Tables = (params) => {
    return WeaTools.callApi('/api/hrm/rewardsrecord/getTrainRewardsRecord1Tables', 'GET', params);
}

export const getSearchList = (params) => {
    return WeaTools.callApi('/api/hrm/rewardsrecord/getSearchResult', 'POST', params);
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/apis/rewardsrecord.js